module.exports = __webpack_public_path__ + "static/media/loading-spin-min.7e2885af.gif";